export const handleOnChange = <T>(
  e: React.FormEvent,
  setFormData: (arg: T) => void,
  formData: T
) => {
  const target = e.target as HTMLInputElement;
  setFormData({ ...formData, [target.name]: target.value });
};
